import { AppPage } from 'common/Layout';
import { EducationPlans } from 'features/education-plans';
import { homeBreadcrumbItem } from 'shared/UI/UIKit/Breadcrumbs';

const breadcrumbs = [
  homeBreadcrumbItem,
  {
    title: 'Учебные планы',
    url: '',
  },
];

export const EducationPlansPage = () => {
  return (
    <AppPage breadcrumbs={{ items: breadcrumbs }} documentTitle="Учебные планы">
      <EducationPlans />
    </AppPage>
  );
};
